module.exports = __webpack_public_path__ + "static/media/one_on_ones.bf3dbea9.svg";